import errorMixin from "vue-error-page/src/errorMixin";
import RequestHandler from "~/utils/request-handler";
import {UrlServices} from "~/utils/url-manager";
import store from "~/store";

export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function () {
      this.snackbar = {
        show: true,
        color: 'green',
        text: this.$t('app.msg_login_success'),
        timeout: 3000
      };
      this.$store.dispatch('setIsLoggedIn', true).then(() => {

        let redirect_url = this.$store.state.redirect_url;
        if(redirect_url){
          this.$router.replace(redirect_url);
          this.$store.dispatch('setRedirectUrl', "");
        } else {
          this.$router.replace({ name: 'event_list' });
        }

      });
    }
  },
  {
    name: 'APP_START_LOADING',
    callback: function() {
      this.loading = true;
    }
  },
  {
    name: 'APP_STOP_LOADING',
    callback: function() {
      this.loading = false;
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function () {
      this.$store.dispatch('setIsLoggedIn', false).then(() => {
        this.snackbar = {
          show: true,
          color: 'green',
          text: this.$t('app.msg_logout_success'),
          timeout: 3000
        };
        this.$router.push({
          name: (this.$store.state.login_type === 'public' ? 'public_login' : 'login')
        });
      });
    }
  },
  {
    name: 'APP_SIGNUP_SUCCESS',
    callback: function () {
      this.snackbar = {
        show: true,
        color: 'green',
        text: this.$t('app.msg_signup_success'),
        timeout: 0
      };
      this.$router.replace({ name: 'public_login' });
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function () {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function () {
      this.$store.dispatch('setIsLoggedIn', false).then(() => {
        this.$router.push({
          name: (this.$store.state.login_type === 'public' ? 'public_login' : 'login')
        });
      });
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'NETWORK_ERROR',
    callback: function () {
      this.snackbar = {
        show: true,
        color: 'red',
        text: this.$t('app.msg_network_error'),
        timeout: 3000
      };
    }
  },
  {
    name: 'UPDATE_AVAILABLE_TEAM',
    callback: function() {
      let me = this;
      RequestHandler.Post(UrlServices.createUrl({'name': 'api_get_available_team'}), {}, {
        'success': function(data) {
          me.$store.dispatch('setTeamsData', data['available_teams']).then();
          me.$store.dispatch('setUserInfo', data['user_info']).then();
        }
      });
    }
  }
];
